(function () {
  'use strict';

  function initCarousel(root) {
    if (!root || root.dataset.ecloInlineReviewsReady === 'true') return;

    var track = root.querySelector('[data-review-track]');
    var viewport = root.querySelector('[data-review-viewport]');
    var reviews = Array.prototype.slice.call(root.querySelectorAll('[data-review-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-review-dot]'));
    var counter = root.querySelector('[data-review-current]');
    if (!track || !viewport || !reviews.length) return;

    var current = 0;
    var touchStartX = null;
    var touchStartY = null;

    function show(index) {
      current = (index + reviews.length) % reviews.length;
      track.style.transform = 'translate3d(' + (-current * 100) + '%,0,0)';

      dots.forEach(function (dot, i) {
        var active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (counter) counter.textContent = String(current + 1);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.reviewDot, 10));
      });
    });

    var prev = root.querySelector('[data-review-prev]');
    var next = root.querySelector('[data-review-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    viewport.addEventListener('touchstart', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      touchStartX = event.changedTouches[0].clientX;
      touchStartY = event.changedTouches[0].clientY;
    }, { passive: true });

    viewport.addEventListener('touchend', function (event) {
      if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;
      var deltaX = event.changedTouches[0].clientX - touchStartX;
      var deltaY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY)) {
        show(current + (deltaX < 0 ? 1 : -1));
      }
      touchStartX = null;
      touchStartY = null;
    }, { passive: true });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });

    show(0);
    root.dataset.ecloInlineReviewsReady = 'true';
  }

  function initAll(scope) {
    var parent = scope || document;
    var selector = '[data-regenere-inline-reviews], [data-patchs-editorial-reviews]';
    Array.prototype.forEach.call(parent.querySelectorAll(selector), initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();